module.exports = __webpack_public_path__ + "img/ic_map_congress.27bdbac1.svg";